import React from "react";
import moment from "moment";

import ActivityType from "../ActivityType";
import CommunicationReceiverAndChannel from "../CommunicationReceiverAndChannel";

import "./index.scss";

const ActivityRow = ({ row, appointment, t }) => {
  const formattedTime = row.time ? moment(row.time).format("DD-MM-YYYY HH:mm") : "";

  const remark = row.receiver ? <CommunicationReceiverAndChannel receiver={row.receiver} t={t} /> : row.note || null;

  return (
    <div className="activity-row">
      <div className="activity-row-main">
        <div className="activity-row-type">
          <ActivityType
            activityType={row.activityType}
            eventType={row.eventType}
            statusIdentifier={row.statusIdentifier}
            isDeskCheckOut={row.isDeskCheckOut}
            keylockerPinRequestType={row.keylockerPinRequestType}
            activityTitle={row.activityTitle}
            appointmentLogType={row.appointmentLogType}
            appointment={appointment}
            t={t}
          />
        </div>

        <div className="activity-row-name">
          {row.name && (
            <span className="activity-row-field">
              <span className="activity-row-field-label">{t("cc_user_customer").message || "User / Customer"}:</span>
              <span className="activity-row-field-value">{row.name}</span>
            </span>
          )}
        </div>

        <div className="activity-row-time">
          {formattedTime && (
            <span className="activity-row-field">
              <span className="activity-row-field-label">{t("cc_time").message || "Time"}:</span>
              <span className="activity-row-field-value">{formattedTime}</span>
            </span>
          )}
        </div>
      </div>

      {remark && (
        <div className="activity-row-remark">
          <span className="activity-row-field">
            <span className="activity-row-field-label">{t("cc_remark").message || "Remark"}:</span>
            <span className="activity-row-field-value">{remark}</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default ActivityRow;
